import { useLocalizedPath } from "../i18n/useLocalizedPath";
import React from "react";
import { Box, Flex, HStack, Link, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const localizePath = useLocalizedPath();
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { label: t("header.about"), href: "/about" },
    { label: t("footer.diary"), href: "/diary-app" },
    { label: t("header.news"), href: "/news" },
    { label: t("header.explore"), href: "/explore" },
    { label: t("header.hexaco"), href: "/hexaco" },
    { label: t("footer.privacyPolicy"), href: "/privacy" },
    { label: t("footer.terms"), href: "/tnc" },
    { label: t("footer.contact"), href: "/#contact" },
  ];

  return (
    <Box as="footer" bg="#23272F" color="white" py={{ base: 7, md: 8 }} px={6}>
      <Flex
        direction={{ base: "column", md: "row" }}
        align={{ base: "flex-start", md: "center" }}
        justify="space-between"
        maxW="1400px"
        mx="auto"
        gap={5}
      >
        <VStack align="flex-start" spacing={1}>
          <Text fontWeight="800">Deep Soul</Text>
          <Text color="whiteAlpha.700" fontSize="sm">
            {t("footer.copyright", { year: currentYear })}
          </Text>
        </VStack>

        <HStack spacing={{ base: 4, md: 6 }} wrap="wrap">
          {footerLinks.map((link) => (
            <Link
              key={link.href}
              href={localizePath(link.href)}
              color="whiteAlpha.800"
              fontSize="sm"
              _hover={{ color: "white" }}
              _focusVisible={{
                outline: "3px solid",
                outlineColor: "primary.300",
                outlineOffset: "3px",
              }}
            >
              {link.label}
            </Link>
          ))}
        </HStack>
      </Flex>
    </Box>
  );
};

export default Footer;

